import { ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import { Box, Collapse, List, Tooltip, Typography } from "@mui/material";
import React from "react";

interface SidebarSectionProps {
  title: string;
  isExpanded: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  isMobile?: boolean;
}

export const SidebarSection: React.FC<SidebarSectionProps> = ({
  title,
  isExpanded,
  onToggle,
  children,
  isMobile = false,
}) => {
  return (
    <>
      <Box
        className="bg-gradient-to-br from-[rgba(79,70,229,0.02)] to-[rgba(0,102,255,0.02)]"
        role="button"
        tabIndex={0}
        aria-expanded={isExpanded}
        onClick={onToggle}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onToggle();
          }
        }}
        sx={{
          px: 2.5,
          py: 1,
          minHeight: 44,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderRadius: "8px",
          mx: 1,
          mb: 0.5,
          cursor: "pointer",
          userSelect: "none",
        }}
      >
        <Typography
          className="bg-gradient-to-br from-[rgba(79,70,229,0.8)] to-[rgba(0,102,255,0.8)] bg-clip-text text-transparent"
          variant="caption"
          sx={{
            fontSize: "0.75rem",
            fontWeight: 700,
            textTransform: "uppercase",
            letterSpacing: "0.05em",
          }}
        >
          {title}
        </Typography>
        <Tooltip title={isExpanded ? "Collapse" : "Expand"}>
          <Box
            component="span"
            aria-hidden="true"
            sx={{
              p: 0.5,
              width: 28,
              height: 28,
              flexShrink: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "8px",
              overflow: "hidden",
              background:
                "/* @noflip */ linear-gradient(135deg, rgba(79, 70, 229, 0.1) 0%, rgba(0, 102, 255, 0.1) 100%)",
              color: "rgba(79, 70, 229, 0.8)",
              transition: "all 0.2s ease-in-out",
              "& .MuiTouchRipple-root": {
                borderRadius: "inherit",
              },
              "& .MuiTouchRipple-child": {
                borderRadius: "8px",
              },
              "&:hover": {
                background:
                  "/* @noflip */ linear-gradient(135deg, rgba(79, 70, 229, 0.15) 0%, rgba(0, 102, 255, 0.15) 100%)",
                transform: "scale(1.05)",
                color: "rgba(79, 70, 229, 1)",
              },
            }}
          >
            {isExpanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
          </Box>
        </Tooltip>
      </Box>
      <Collapse in={isExpanded} timeout="auto" unmountOnExit={false}>
        <List
          component="div"
          dense
          sx={{
            px: isMobile ? 1 : 1.5,
            pt: 0.5,
            pb: 0,
          }}
        >
          {children}
        </List>
      </Collapse>
    </>
  );
};
